var alignment_default = {
  "alignLeft": "BRGGa",
  "textWrapNowrap": "zVDmV",
  "alignRight": "_5y1-F",
  "alignCenter": "wPR58",
  "sizeFullWidth": "urA9C",
  "renderedInTable": "Hlwxs",
  "sizeOriginal": "_7YmWl",
  "sizeContent": "tvTED",
  "sizeSmall": "WGrFn",
  "sizeSmallCenter": "FSzjn",
  "flex": "i1-d9",
  "LEFT": "_6BPOs",
  "CENTER": "_5BrfB",
  "RIGHT": "CfaEE",
  "AUTO": "ewTCf",
  "JUSTIFY": "amZBh"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
